import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchGeoInfo } from 'actions/geoInfo';

export const useGeoInfo = () => {
  const dispatch = useDispatch();
  const [geoInfo, setGeoInfo] = useState(null);

  useEffect(() => {
    const fetchGeoInfoData = async () => {
      const results = await dispatch(fetchGeoInfo());

      if (results) {
        setGeoInfo(results);
      }
    };
    fetchGeoInfoData();
  }, [dispatch]);

  return geoInfo;
};
